/**
 * InitializeAuthNavigator - Initializes the navigator for AuthContext
 * 
 * Sets up the navigate function in AuthContext so it can be used
 * for redirects outside of React components.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigator } from '../../../context/auth';

function InitializeAuthNavigator() {
  const navigate = useNavigate();
  
  useEffect(() => {
    setNavigator(navigate);
    console.log('App.jsx: Auth navigator initialized');
  }, [navigate]);
  
  return null; // This component does not render anything
}

export default InitializeAuthNavigator;

